// src/services/axiosInstances.js
import axios from 'axios';
import Cookies from 'js-cookie';

const createAxiosInstance = baseUrl => {
  const instance = axios.create({
    baseURL: baseUrl,
    timeout: 60 * 1000, // 1 minute
    headers: {
      'Content-Type': 'application/json',
    },
  });

  const onRequestSuccess = config => {
    const token = Cookies.get('vpg-authentication-token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  };

  const onResponseSuccess = response => response;

  const onResponseError = err => {
    const status = err.response ? err.response.status : null;
    if (status === 403 || status === 401) {
      // Add your unauthenticated handling logic here
    }
    return Promise.reject(err);
  };

  instance.interceptors.request.use(onRequestSuccess);
  instance.interceptors.response.use(onResponseSuccess, onResponseError);

  return instance;
};

export const apiOkr = createAxiosInstance(SERVER_API_OKR);
export const apiOrg = createAxiosInstance(SERVER_API_ORG);
export const apiComment = createAxiosInstance(SERVER_API_COMMENT);
export const apiProcess = createAxiosInstance(SERVER_API_PROCESS);
export const apiWorkFollow = createAxiosInstance(SERVER_API_WORK_FOLLOW_MONITOR);
